import * as React from 'react';
import { useContext, createContext } from 'react';

export interface TabSwitcherProps {
  value: string;
  children: React.ReactNode;
}

export interface TabPanelProps {
  id: string;
  children: React.ReactNode;
}

const TabSwitcherContext = createContext<string>('');

/**
 * This is TabPanel
 * @public
 */
const TabPanel = ({ id, children }: TabPanelProps) => {
  const value = useContext(TabSwitcherContext);

  return <>{value === id ? children : null}</>;
};

/**
 * This is a TabSwitcher
 * @public
 */
const TabSwitcher = ({ value, children }: TabSwitcherProps) => {
  return <TabSwitcherContext.Provider value={value}>{children}</TabSwitcherContext.Provider>;
};

export { TabSwitcher, TabPanel };
